import { hyperdbHandlers } from 'hyperdb-utils';

const handlers = hyperdbHandlers({ namespace: 'PROPERTY' });
export default {
  ...handlers,
  PROPERTY__UPLOAD_PICTURE(state) {
    return { ...state, uploadingPicture: true, errorMessage: null, uploadSuccess: false };
  },
  PROPERTY__UPLOAD_PICTURE_SUCCESS(state, { payload }) {
    const savedPicture = payload;
    return { ...state, savedPicture, uploadingPicture: false, errorMessage: null, uploadSuccess: true };
  },
  PROPERTY__DELETE_PICTURE(state) {
    return { ...state, deletingPicture: true, errorMessage: null, deletePictureSuccess: false };
  },
  PROPERTY__DELETE_PICTURE_SUCCESS(state) {
    return { ...state, deletingPicture: false, errorMessage: null, deletePictureSuccess: true };
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/handlers.js